import { render, staticRenderFns } from "./FriendLinkMobile.vue?vue&type=template&id=2ded0961&scoped=true"
import script from "./FriendLinkMobile.vue?vue&type=script&lang=js"
export * from "./FriendLinkMobile.vue?vue&type=script&lang=js"
import style0 from "./FriendLinkMobile.vue?vue&type=style&index=0&id=2ded0961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded0961",
  null
  
)

export default component.exports